import { UpdateKeyValueRequest } from "@models/base/updateKeyValueRequest.model"

export class UpdateIndiceAjusteContratoRequest extends UpdateKeyValueRequest{
  public valor!: number
  public fecha!: string
  public activo!: boolean
  public idTipoAjusteContrato!: number
}
